'use client';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LeaveRegistration } from '../LeaveRegistration';
import { LEAVE_REGISTRATION_MODAL_SHOWN } from './helper';
import { AnalyticsEventName } from '@/api/analytics';
import { Button, ButtonClose } from '@/components/buttons';
import { HasModalShown } from '@/components/Deposit/helpers';
import { ImageComponent } from '@/components/Image';
import { Modal } from '@/components/Modal';
import { ModalsList } from '@/helpers/breadcrumbModal';
import { useAddBreadcrumbModal } from '@/hooks/addBreadcrumbModal';
import { useAnalytics } from '@/hooks/analytics';

import {
  ScBonusText,
  ScBonusValue,
  ScLeaveRegistration,
  ScTitle,
} from './styled';

export type LeaveRegistrationProps = {
  onClose: () => void;
  onCloseRegistration: () => void;
  isModalTypeB?: boolean;
};

export const LeaveRegistrationModal: FC<LeaveRegistrationProps> = ({
  onClose,
  onCloseRegistration,
  isModalTypeB,
}) => {
  const { t } = useTranslation(['common', 'wheel']);
  const { sendEventToAnalytics } = useAnalytics();

  useAddBreadcrumbModal(ModalsList.LEAVE_REGISTRATION);

  const handleButtonClose = () => {
    onCloseRegistration();
    onClose();
    sessionStorage.setItem(LEAVE_REGISTRATION_MODAL_SHOWN, HasModalShown.TRUE);
    sendEventToAnalytics({
      name: AnalyticsEventName.MODAL__REG_EXIT_POPUP1_CROSS__CLICK,
    });
  };

  const handleRegisterButton = () => {
    onClose();
    sessionStorage.setItem(LEAVE_REGISTRATION_MODAL_SHOWN, HasModalShown.TRUE);
    sendEventToAnalytics({
      name: AnalyticsEventName.MODAL__REG_EXIT_POPUP1__REGISTER__CLICK,
    });
  };

  if (!isModalTypeB) {
    return (
      <Modal>
        <LeaveRegistration
          onClose={onClose}
          onCloseRegistration={onCloseRegistration}
        />
      </Modal>
    );
  }

  return (
    <Modal>
      <ScLeaveRegistration>
        <ButtonClose dark onClick={handleButtonClose} top={8} right={8} />
        <ImageComponent
          width={80}
          height={80}
          src="/emojis/thinkingEmoji.webp"
          alt="thinking emoji"
          className="emoji-img"
        />
        <ScTitle>{t('common:registrationLeavingA.title')}</ScTitle>
        <p className="leaving-text">{t('common:registrationLeavingA.text')}</p>
        <ScBonusValue> 100% + {t('wheel:FS', { amount: 100 })}</ScBonusValue>
        <ScBonusText>{t('common:registrationLeavingA.bonusText')}</ScBonusText>

        <div className="buttons">
          <Button
            autoPaddingHorizontal
            wide
            small
            primary
            onClick={handleRegisterButton}
            large
          >
            {t('common:registrationLeavingA.register')}
          </Button>
        </div>
      </ScLeaveRegistration>
    </Modal>
  );
};
